import { render, staticRenderFns } from "./remainingLife.vue?vue&type=template&id=30da79b2&scoped=true"
import script from "./remainingLife.vue?vue&type=script&lang=ts"
export * from "./remainingLife.vue?vue&type=script&lang=ts"
import style0 from "./remainingLife.vue?vue&type=style&index=0&id=30da79b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da79b2",
  null
  
)

export default component.exports